module.exports = __webpack_public_path__ + "img/new_age_04.f53f70df.jpg";